import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { DownloadableBlob } from '@ps/utils';
import { ExternalBuyerMappingsService } from '../../../services/external-buyer-mappings.service';
import { ExternalBuyerMappingsActions } from '../actions/external-buyer-mappings.actions';

@Injectable()
export class ExternalBuyerMappingsEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(ExternalBuyerMappingsService);
  private readonly _document = inject(DOCUMENT);

  public readonly uploadMappings$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ExternalBuyerMappingsActions.uploadMappings),
      switchMap(({ file, buyerId, buyerKey }) =>
        this._service.uploadMappings(file, buyerId, buyerKey).pipe(
          map(({ count }) =>
            ExternalBuyerMappingsActions.uploadMappingsSuccess({
              count: count ?? 0,
            }),
          ),
          catchError((error: unknown) =>
            of(
              ExternalBuyerMappingsActions.uploadMappingsFailure({
                error: String(error),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public readonly downloadMappings$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ExternalBuyerMappingsActions.downloadMappings),
      switchMap(({ buyerId, fileName }) =>
        this._service.downloadMappings(buyerId).pipe(
          tap((blob) =>
            new DownloadableBlob(blob, fileName, this._document).download(),
          ),
          map(() => ExternalBuyerMappingsActions.downloadMappingsSuccess()),
          catchError((error: unknown) =>
            of(
              ExternalBuyerMappingsActions.downloadMappingsFailure({
                error: String(error),
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
